<template>
    <div v-if="!isLoading" class="view-entry">
        <page-header
            slot-class="view-entry__menu"
            action-slot-class="view-entry__action"
            :headroom-disabled="pinningDisabled"
        >
            <transition-expand>
                <ul class="menu" v-if="showMenu">
                    <li
                        class="menu__item"
                        v-for="jumpmark in getJumpmarks"
                        :key="`jumpmark-${jumpmark.id}`"
                    >
                        <a
                            href="#"
                            v-scroll-to="{
                                el: `#jumpmark-${jumpmark.id}`,
                                offset: scrollOffset,
                                onStart: scrollStart,
                                onDone: scrollEnd,
                                onCancel: scrollEnd,
                            }"
                        >{{ jumpmark.name }}</a>
                    </li>
                    <li class="menu__item menu__item--logout"><a href="#/logout"><svgicon name="logout"/>{{ t('logout') }}</a></li>
                </ul>
            </transition-expand>

            <span slot="action" style="color: white;" class="menu__button" @click="toggleMenu">Menu</span>
        </page-header>

        <div class="section-dimensioning section-dimensioning--medium content-dimensioning">
            <template  v-for="(section, index) in getSections">

                <div
                    v-if="section.component && section.component.hasOwnProperty('jumpmark')"
                    :id="`jumpmark-${section.component.jumpmark.id}`"
                    :key="`entry-section-${index}`"
                ></div>

                <base-section
                    v-else
                    :key="`entry-section-${index}`"
                    :section="section">
                </base-section>
            </template>
        </div>

        <page-footer></page-footer>

        <!-- <portal to="modals" v-if="enforceCompliance">
            <modal-element
                :content="!!complianceContent.length ? complianceContent[0] : null"
                :open="enforceCompliance"
            >
                <compliance-element slot="component" @done="closeModal" />
            </modal-element>
        </portal> -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
    UITEXTS_FETCH_NS,
    PAGE_FETCH_NS,
    PAGE_SET_NS,
    ME_FETCH_NS,
    GENERAL_ENTRY_FETCH_NS,
} from "@/store/actions.type";

import PageHeader from '@/components/common/PageHeader.vue';
import PageFooter from '@/components/common/PageFooter.vue';
import BaseSection from '@/components/sections/BaseSection.vue';
import ModalElement from '@/components/elements/ModalElement.vue';
// import ComplianceElement from '@/components/elements/specials/ComplianceElement.vue';
import TransitionExpand from '@/components/transitions/TransitionExpand.vue';

export default {
    name: 'GeneralEntryView',
    components: {
        PageHeader,
        BaseSection,
        PageFooter,
        ModalElement,
        // ComplianceElement,
        TransitionExpand,
    },
    props: {
        content: Object
    },
    data() {
        return {
            // enforceCompliance: false,
            menuVisible: false,
            pinningDisabled: false,
        }
    },
    computed: {
        ...mapGetters('uitexts', {
            isLoadingUiTexts: 'isLoading',
            t: 't',
        }),

        ...mapGetters('header', {
            getHeaderHeight: 'getHeight',
            isHeaderPinned: 'isPinned',
        }),

        ...mapGetters('page', {
            getSections: 'getSections',
            getJumpmarks: 'getJumpmarks',
            isLoadingEntry: 'isLoading',
        }),

        ...mapGetters('me', {
            isLoadingMe: 'isLoading',
            me: 'getMe',
        }),

        // ...mapGetters('generalEntry', {
        //     complianceContent: 'getSections',
        //     isLoadingCompliance: 'isLoading',
        // }),

        mustAcceptCompliance() {
            return this.me.hasOwnProperty('participantCompliance') && this.me.participantCompliance !== true;
        },

        isLoading() {
            return this.isLoadingUiTexts || this.isLoadingEntry || this.isLoadingMe;// || this.isLoadingCompliance;
        },

        showMenu() {
            return (this.menuVisible && this.$mq == 'sm') || ['md', 'lg'].indexOf(this.$mq) !== -1;
        },

        scrollOffset() {
            return this.isHeaderPinned ? (this.getHeaderHeight * -1) : 0;
        },
    },
    async beforeRouteEnter(to, from, next) {
        if (window.isLivePreview) {
            return next();
        }

        await store.dispatch(UITEXTS_FETCH_NS);
        const me = await store.dispatch(ME_FETCH_NS);

        if (me && me.isKam) {
            await store.dispatch(PAGE_FETCH_NS, 'kam-startseite');
        } else if (me && me.participantIcs === true) {
            await store.dispatch(PAGE_FETCH_NS, 'ics-startseite');
        } else {
            await store.dispatch(PAGE_FETCH_NS, 'startseite');
        }

        return next();
    },
    async created() {
        if (this.content) {
            store.dispatch(PAGE_SET_NS, this.content);
            await store.dispatch(UITEXTS_FETCH_NS);
        }

        // if (this.mustAcceptCompliance) {
        //     this.enforceCompliance = this.mustAcceptCompliance;
        // }
    },

    watch: {
        isHeaderPinned(newValue, oldValue) {

            if (newValue == false) {
                this.menuVisible = false;
            }
        },
    },

    methods: {
        toggleMenu() {
            this.menuVisible = !this.menuVisible;
        },

        closeModal() {
            this.enforceCompliance = false;
        },

        scrollStart() {
            this.pinningDisabled = true;
            this.menuVisible = false;
        },

        scrollEnd() {
            this.pinningDisabled = false;
        },
    },
}
</script>
